import { AnyAction } from 'redux';
import { NewHireStep } from '../../new-hire/models/new-hire-model';
import { PlanTypes } from '../enrollment/models/coverage-models';
import { NewHireEnrollmentAppActions, NewHireEnrollmentAppState, NewHireEnrollmentStep } from '../models/new-hire-enrollment-models';
import { BenefitEnrollmentStep } from '../models/pension-enrollment-models';
import { WhoWillEnrollCriterias } from '../models/who-will-enroll-models';
import { MyCpgMidYearEnrollment } from '../member/models/member-coverage-model';
import { ApiStatuses } from '../../../../../global/models/api-model';


const InitialState: NewHireEnrollmentAppState = {
	currentStep: null,
	currentEnrollmentStep: null,
	currentEmployeeReviewStep: null,
	isEligible: true,
	enrollmentOptions: null,
	newHireCoverageState: null,
	newHireCoverageLoaded: false,
	tierToDisplayMedical: null,
	tierToDisplayDental: null,
	memberEmployment: null,
	memberEmploymentLoaded: false,
	memberCompensation: null,
	memberCompensationLoaded: false,
	memberCurrentEmploymentId: 0,
	memberCurrentEmploymentIdLoaded: false,
	memberPensionInfo: null,
	memberPensionInfoLoaded: false,
	memberCurrentEmployer: null,
	whoWillEnrollCriteria: null,
	memberCoverageState: null,
	memberGhlEnrollments: null,
	calculatedVolumeRateValues: null,
	adminGhlpendingEnrollments: null,
	dioApproverCurrentFormId: null,
	myCpgPendingForApprovalEnrollment: null,
	isLifeEventCoverageForm: false,
};

export const newHireEnrollmentReducer = (state = InitialState, action: AnyAction): NewHireEnrollmentAppState => {


	switch (action.type) {
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_CURRENT_STEP:
			return {
				...state,
				currentStep: action.payload,
			};

		case NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_ELIGIBILITY:
			return {
				...state,
				isEligible: action.payload,
			};

		case NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_OPTIONS:
			return {
				...state,
				enrollmentOptions: action.payload,
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_ENROLLMENT_OPTIONS:
			return {
				...state,
				enrollmentOptions: null,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_COVERAGE:
			return {
				...state,
				newHireCoverageState: action.payload,
				newHireCoverageLoaded: true,
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_ENROLLMENT_COVERAGE:
			return {
				...state,
				newHireCoverageState: null,
				newHireCoverageLoaded: false,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_TIER:
			if (action.payload.plan === PlanTypes.D) {
				return {
					...state,
					tierToDisplayDental: action.payload.tier,
				};
			}
			return {
				...state,
				tierToDisplayMedical: action.payload.tier,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_BENEFIT_ENROLLMENT_CURRENT_STEP:
			return {
				...state,
				currentEnrollmentStep: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_EMPLOYEE_REVIEW_CURRENT_STEP:
			return {
				...state,
				currentEmployeeReviewStep: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_EMPLOYMENT_DATA:
			return {
				...state,
				memberCurrentEmploymentId: action.payload?.employmentId,
				memberCurrentEmployer: action.payload?.employer,
				memberCurrentEmploymentIdLoaded: true,
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT_DATA:
			return {
				...state,
				memberCurrentEmploymentId: null,
				memberCurrentEmploymentIdLoaded: false,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_EMPLOYMENT:
			return {
				...state,
				memberEmployment: action.payload,
				memberEmploymentLoaded: true,
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT:
			return {
				...state,
				memberEmployment: null,
				memberEmploymentLoaded: false,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_COMPENSATION:
			return {
				...state,
				memberCompensation: action.payload,
				memberCompensationLoaded: true,
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_COMPENSATION:
			return {
				...state,
				memberCompensation: null,
				memberCompensationLoaded: false,
			};
		case NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_PENSION_INFO:
			return {
				...state,
				memberPensionInfo: action.payload,
				memberPensionInfoLoaded: true,
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_PENSION_INFO:
			return {
				...state,
				memberPensionInfo: null,
				memberPensionInfoLoaded: false,
			};
		case NewHireEnrollmentAppActions.SET_MEMBER_NEW_HIRE_COVERAGE:

			return {
				...state,
				memberCoverageState: action.payload,
			};
		case NewHireEnrollmentAppActions.CLEAR_MEMBER_NEW_HIRE_COVERAGE:
			return {
				...state,
				memberCoverageState: null,
			};
		case NewHireEnrollmentAppActions.SET_MEMBER_GHL_ENROLLMENTS:
			return {
				...state,
				memberGhlEnrollments: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_ADMIN_GHL_PENDING_ENROLLMENTS:
			return {
				...state,
				adminGhlpendingEnrollments: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_DIO_APPROVER_CURRENT_FORM_ID:
			return {
				...state,
				dioApproverCurrentFormId: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_IS_LIFE_EVENT_COVERAGE_FORM:
			return {
				...state,
				isLifeEventCoverageForm: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_RATE_USING_VOLUME:
			return {
				...state,
				calculatedVolumeRateValues: {
					...state.calculatedVolumeRateValues,
					...action.payload,
				},
			};
		case NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_ENROLLMENT_STATE:
			return {
				currentStep: null,
				currentEnrollmentStep: null,
				currentEmployeeReviewStep: null,
				isEligible: true,
				enrollmentOptions: null,
				newHireCoverageState: null,
				newHireCoverageLoaded: false,
				tierToDisplayMedical: null,
				tierToDisplayDental: null,
				memberEmployment: null,
				memberEmploymentLoaded: false,
				memberCompensation: null,
				memberCompensationLoaded: false,
				memberCurrentEmploymentId: 0,
				memberCurrentEmployer: null,
				memberCurrentEmploymentIdLoaded: false,
				memberPensionInfo: null,
				memberPensionInfoLoaded: false,
				whoWillEnrollCriteria: null,
				memberCoverageState: null,
				memberGhlEnrollments: null,
				calculatedVolumeRateValues: null,
				adminGhlpendingEnrollments: null,
				dioApproverCurrentFormId: null,
				myCpgPendingForApprovalEnrollment: null,
				isLifeEventCoverageForm: false,
			};
		case NewHireEnrollmentAppActions.SET_WHO_WILL_ENROLL_CRITERIA:
			return {
				...state,
				whoWillEnrollCriteria: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_MYCPG_MIDYEAR_OPEN_ENROLLMENT:
			return {
				...state,
				myCpgOpenEnrollment: action.payload,
			};
		case NewHireEnrollmentAppActions.SET_MYCPG_MIDYEAR_PENDING_APPROVAL_ENROLLMENT:
			return {
				...state,
				myCpgPendingForApprovalEnrollment: action.payload,
			};

		case NewHireEnrollmentAppActions.SET_COVERAGE_FORM_ERROR:
			return {
				...state,
				apiError: ApiStatuses.Failure,
			};

		default: return state;
	}
};

export const setCurrentNewHireEnrollmentStep = (step: NewHireEnrollmentStep) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_CURRENT_STEP,
		payload: step,
	};
};

export const setCurrentNewHireEnrollmentEligibility = (isEligible: boolean) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_ELIGIBILITY,
		payload: isEligible,
	};
};

export const setNewHireEnrollmentOptions = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_OPTIONS,
		payload: data,
	};
};

export const clearNewHireEnrollmentOptions = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_ENROLLMENT_OPTIONS,
	};
};

export const setNewHireEnrollmentCoverage = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_ENROLLMENT_COVERAGE,
		payload: data,
	};
};

export const clearNewHireEnrollmentCoverage = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_ENROLLMENT_COVERAGE,
	};
};

export const setNewHireTier = (plan, data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_TIER,
		payload: {
			plan,
			tier: data,
		},
	};
};


export const setCurrentNewHireBenefitEnrollmentStep = (step: BenefitEnrollmentStep) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_BENEFIT_ENROLLMENT_CURRENT_STEP,
		payload: step,
	};
};


export const clearNewHireEnrollmentState = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_ENROLLMENT_STATE,
	};
};

export const setCurrentNewHireEmployeeReviewStep = (step: NewHireStep) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_EMPLOYEE_REVIEW_CURRENT_STEP,
		payload: step,
	};
};

export const clearNewHireEnrollmentMemberEmployment = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT,
	};
};

export const setNewHireEnrollmentMemeberEmployment = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_EMPLOYMENT,
		payload: data,
	};
};

export const clearNewHireEnrollmentMemberEmploymentData = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_EMPLOYMENT_DATA,
	};
};

export const setNewHireEnrollmentMemeberEmploymentData = (employmentId: number, employer: any) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_EMPLOYMENT_DATA,
		payload:
		{
			employmentId,
			employer,
		},
	};
};

export const clearNewHireEnrollmentMemberCompensation = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_COMPENSATION,
	};
};

export const setNewHireEnrollmentMemberCompensation = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_COMPENSATION,
		payload: data,
	};
};

export const clearNewHireEnrollmentMemberPensionInfo = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_NEW_HIRE_MEMBER_PENSION_INFO,
	};
};

export const setNewHireEnrollmentMemberPensionInfo = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_NEW_HIRE_MEMBER_PENSION_INFO,
		payload: data,
	};
};


export const setWhoWillEnrollCriteria = (data: WhoWillEnrollCriterias) => {
	return {
		type: NewHireEnrollmentAppActions.SET_WHO_WILL_ENROLL_CRITERIA,
		payload: data,
	};
};


export const setMemberNewHireEnrollmentCoverage = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_MEMBER_NEW_HIRE_COVERAGE,
		payload: data,
	};
};

export const clearMemberNewHireEnrollmentCoverage = () => {
	return {
		type: NewHireEnrollmentAppActions.CLEAR_MEMBER_NEW_HIRE_COVERAGE,
	};
};

export const setMemberNewHireGhlEnrollments = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_MEMBER_GHL_ENROLLMENTS,
		payload: data,
	};
};

export const setVolumeAndRate = (volumeValue: number, rateValue: any, groupLifeField: string) => {
	return {
		type: NewHireEnrollmentAppActions.SET_RATE_USING_VOLUME,
		payload: {
			[groupLifeField]: {
				volume: volumeValue,
				rate: rateValue,
			},
		},
	};
};

export const setAdminNewHirePendingGhlEnrollments = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_ADMIN_GHL_PENDING_ENROLLMENTS,
		payload: data,
	};
};

export const setDioApproverCurrentFormId = (data) => {
	return {
		type: NewHireEnrollmentAppActions.SET_DIO_APPROVER_CURRENT_FORM_ID,
		payload: data,
	};
};

export const setMyCpgMidYearOpenEnrollment = (data: MyCpgMidYearEnrollment[]) => {
	return {
		type: NewHireEnrollmentAppActions.SET_MYCPG_MIDYEAR_OPEN_ENROLLMENT,
		payload: data,
	};
};

export const setMyCpgMidYearPendingForApprovalForms = (data: MyCpgMidYearEnrollment[]) => {
	return {
		type: NewHireEnrollmentAppActions.SET_MYCPG_MIDYEAR_PENDING_APPROVAL_ENROLLMENT,
		payload: data,
	};
};

export const setIsLifeEventCoverageForm = (data) => {

	return {
		type: NewHireEnrollmentAppActions.SET_IS_LIFE_EVENT_COVERAGE_FORM,
		payload: data,
	};
};

export const setCoverageFormError = () => {

	return {
		type: NewHireEnrollmentAppActions.SET_COVERAGE_FORM_ERROR,
	};
};